"use client";

import { motion } from 'framer-motion';
import React, { useRef, useState } from 'react';

export default function Magnetic({ children, strength = 0.2, className = "" }: { children: React.ReactNode, strength?: number, className?: string }) {
    const ref = useRef<HTMLDivElement>(null);
    const [position, setPosition] = useState({ x: 0, y: 0 });

    const handleMouse = (e: React.MouseEvent) => {
        const { clientX, clientY } = e;
        const rect = ref.current?.getBoundingClientRect();

        if (rect) {
            const { height, width, left, top } = rect;
            const middleX = clientX - (left + width / 2);
            const middleY = clientY - (top + height / 2);
            setPosition({ x: middleX * strength, y: middleY * strength });
        }
    }

    const reset = () => {
        setPosition({ x: 0, y: 0 });
    }

    const { x, y } = position;
    return (
        <motion.div
            style={{ position: "relative", x, y }}
            ref={ref}
            onMouseMove={handleMouse}
            onMouseLeave={reset}
            className={className}
            transition={{ type: "spring", stiffness: 150, damping: 15, mass: 0.1 }}
        >
            {children}
        </motion.div>
    )
}
